const NAV_ITEMS = [
  {
    key: "formalities",
    label: "Mes demandes de formalités",
  },
  {
    key: "orders",
    label: "Mes commandes",
  },
  {
    key: "profile",
    label: "Mon compte client",
  },
  {
    key: "parameters",
    label: "Mes paramètres de connexion",
  },
];
export default function CustomerSidebar({ active, onChange }) {
  return (
    <nav className="col-12 col-md-3 mb-4 mb-md-0">
      <div className="card shadow-sm">
        <ul className="list-group list-group-flush">
          {NAV_ITEMS.map((item) => {
            const isActive = active === item.key;
            return (
              <li key={item.key} className="list-group-item p-0">
                <button
                  type="button"
                  className={[
                    "w-100",
                    "text-start",
                    "px-3",
                    "py-2",
                    "btn",
                    "btn-link",
                    "decoration-on-hover",
                    isActive ? "fw-semibold bg-primary-10" : "",
                  ].join(" ")}
                  onClick={() => { onChange(item.key) }}
                >
                  {item.label}
                </button>
              </li>
            );
          })}
        </ul>
      </div>
    </nav>
  );
}
